import { hapticFeedback } from '@telegram-apps/sdk-react';

/**
 * Тактильный отклик — заметная часть «нативности» мини-аппа. Все вызовы
 * best-effort: на десктопе и в старых клиентах их просто нет.
 */
function safely(run: () => unknown): void {
  try {
    run();
  } catch {
    // Не поддерживается — молча пропускаем, ради вибрации падать не стоит.
  }
}

export const haptics = {
  /** Смена выбора в списке опций. */
  select: () => safely(() => hapticFeedback.selectionChanged.ifAvailable()),
  /** Переход на следующий шаг. */
  advance: () => safely(() => hapticFeedback.impactOccurred.ifAvailable('light')),
  /** Завершение онбординга. */
  success: () => safely(() => hapticFeedback.notificationOccurred.ifAvailable('success')),
  /** Время на исходе — например, запись голоса подходит к лимиту. */
  warning: () => safely(() => hapticFeedback.notificationOccurred.ifAvailable('warning')),
};
